var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLoader = function SvgLoader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.505 16.08a1.5 1.5 0 0 0 2.898-.776l-2.898.776Zm13.799 5.517a1.5 1.5 0 0 0 .776 2.897l-.776-2.897Zm-10.9-6.294a8.9 8.9 0 0 1 6.293-10.9L9.92 1.505C3.572 3.206-.196 9.732 1.505 16.08l2.898-.776Zm6.293-10.9a8.9 8.9 0 0 1 10.9 6.294l2.897-.777C22.794 3.572 16.268-.196 9.92 1.505l.777 2.898Zm10.9 6.294a8.9 8.9 0 0 1-6.294 10.9l.777 2.897c6.348-1.7 10.116-8.226 8.415-14.574l-2.898.777ZM3.141 20.462a1.5 1.5 0 1 0 2.118-2.125L3.14 20.462Zm2.11-2.133a1.5 1.5 0 1 0-2.118 2.125l2.118-2.125Zm.008.008-.008-.008-2.118 2.125.008.008 2.118-2.125Z",
    fill: "currentColor"
  })));
};
export default SvgLoader;